import { all, call, put, take, race, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { actions as PollingActions, types as PollingTypes } from './actions';
import service from 'commons/services/notifications';

export function* loadTotalNotifications() {
	while (true) {
		try {
			const response = yield call(service.getTotalNotificacaoUsuario);
			yield put(PollingActions.setTotalNotificationsLoaded(response.data.nuTotalNaoProcessado));
			yield call(delay, 60000);
		} catch (error) {
			if (error.response) {
				const { message } = error.response.data;
				console.error(message);
				// eslint-disable-next-line
			}
			yield put(PollingActions.stopPolling());
		}
	}
}

export function* loadBadgeNotifications() {
	try {
		yield put(PollingActions.updateShowPreloader(true));
		yield put(PollingActions.setBadgeActive(false));
		yield call(service.resetTotalNotifications);
		const response = yield call(service.getNotificacaoPaginadoUsuario, 0, 5);
		yield put(PollingActions.setNotifications(response.data.content));
	} catch (error) {
		if (error.response) {
			const { mensagem } = error.response.data;
			yield put(PollingActions.updateShowPreloader(false));
			// eslint-disable-next-line
			console.log('message error: ', mensagem);
		}
	} finally {
		yield put(PollingActions.updateShowPreloader(false));
	}
}

export default function* root() {
	yield all([takeLatest(PollingTypes.GET_BADGE_NOTIFICATIONS, loadBadgeNotifications)]);

	while (true) {
		yield take(PollingTypes.GET_TOTAL_BADGE_NOTIFICATIONS, loadTotalNotifications);
		yield race([call(loadTotalNotifications), take(PollingTypes.STOP_POLLING)]);
	}
}
